


























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencyKBModule } from '@/store/modules/agencyKB';
import Alert from '@/components/Shared/Alert.vue';
import KBSearchResults from '@/components/KnowledgeBase/KBSearchResults.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import TOCSection from '@/models/KnowledgeBase/TOCSection';
import TOCNode from '@/models/KnowledgeBase/TOCNode';
import KBContentListItem from '@/models/KnowledgeBase/KBContentListItem';

@Component({
  name: 'AgencyKnowledgeBase',
  components: {
    Alert,
    KBSearchResults
  }
})
export default class extends GiganautVue {
  private searchQuery = '';
  private showSearchResults = false;

  get tocSections(): TOCSection[] {
    return AgencyKBModule.toc?.published?.structure || [];
  }

  get contentList(): KBContentListItem[] {
    return AgencyKBModule.contentList?.items || [];
  }

  created() {
    // Check if there's a search query in the route
    if (this.$route.query.q) {
      this.searchQuery = this.$route.query.q as string;
      this.performSearch();
    }
  }

  @Watch('$route.query.q')
  onQueryChange(newQuery: string) {
    if (newQuery) {
      this.searchQuery = newQuery;
      this.performSearch();
    } else {
      this.searchQuery = '';
      this.showSearchResults = false;
      AgencyKBModule.clearSearch();
    }
  }

  getSlugForContent(contentId: string): string {
    const item = this.contentList.find(c => c.id === contentId);
    return item?.slug || contentId;
  }

  performSearch() {
    if (this.searchQuery && this.searchQuery.trim()) {
      this.showSearchResults = true;
      AgencyKBModule.search({
        query: this.searchQuery,
        semantic: true,
        limit: 20
      });
    }
  }

  navigateToArticle(slug: string) {
    this.$router.push({
      name: 'AgencyKBArticle',
      params: { slug }
    });
  }

  navigateToFirstArticle(section: TOCSection) {
    const firstArticle = this.findFirstArticle(section.items);
    if (firstArticle && firstArticle.contentId) {
      const slug = this.getSlugForContent(firstArticle.contentId);
      this.navigateToArticle(slug);
    }
  }

  // Recursively find the first article in a node tree
  findFirstArticle(nodes: TOCNode[]): TOCNode | null {
    if (!nodes || nodes.length === 0) return null;

    for (const node of nodes) {
      if (node.type === 'article' && node.contentId) {
        return node;
      } else if (node.type === 'folder' && node.items && node.items.length > 0) {
        const article = this.findFirstArticle(node.items);
        if (article) return article;
      }
    }
    return null;
  }

  // Recursively count articles in a section (including nested in folders)
  countArticlesInSection(section: TOCSection): number {
    return this.countArticles(section.items || []);
  }

  countArticles(nodes: TOCNode[]): number {
    let count = 0;
    for (const node of nodes) {
      if (node.type === 'article') {
        count++;
      } else if (node.type === 'folder' && node.items) {
        count += this.countArticles(node.items);
      }
    }
    return count;
  }
}
